export default __webpack_public_path__ + "static/media/ql_04.7dcaca18.png";